import { jsx as c } from "react/jsx-runtime";
import { SvgIcon as h } from "./SvgIcon.js";
const l = (e) => /* @__PURE__ */ c(h, { ...e, children: /* @__PURE__ */ c(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m3.79453 15.15.9625-3.0437 3.75938-.0032 1 3.0438h1.54689L7.55703 4.71564h-1.85c-.32465.97834-.94494 2.92298-1.57681 4.90392C3.41185 11.8717 2.67851 14.1707 2.34766 15.15h1.44687Zm3.72038-6.32431c.1963.59486.42002 1.27281.67025 2.04311H5.07578c.07197-.2251.14219-.4442.21057-.6576.58483-1.82509 1.03482-3.22939 1.28943-4.32056h.02188c.14682.60042.45652 1.53891.91725 2.93505ZM17.6523 15.1469c-.0687-.4344-.1156-1.2344-.1156-1.7656l.0031-3.66253c0-1.78437-1.1312-2.42812-2.7812-2.42812-2.1094 0-2.85 1.0875-2.9594 2.3625h1.3719c.1187-.79688.4719-1.3 1.55-1.3 1.2281 0 1.4344.70312 1.4344 1.41562v.71253h-1.1282c-2.7406 0-3.5312 1.2593-3.5312 2.4625 0 1.0875.5937 2.3406 2.4812 2.3406 1.2282 0 1.9969-.5313 2.2969-1.2781.0063.4531.0594.8812.1125 1.1406h1.2656Zm-2.625-3.6781h1.1657v.1593c0 1.5438-.4594 2.5219-1.9125 2.5219-.9313 0-1.3594-.5906-1.3594-1.2969 0-.6656.3344-1.3843 2.1062-1.3843Z"
  }
) });
export {
  l as CaseSensitive
};
//# sourceMappingURL=CaseSensitive.js.map
